module.exports = __webpack_public_path__ + "static/img/LouvreCourse.922530a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/LouvreCourse.png
// module id = IPGp
// module chunks = 1